import React from "react";

function ContentLayout({ children }) {
  return (
    <div className="flex min-h-[250px] flex-col items-center gap-4 text-center md:items-start md:text-left">
      {children}
    </div>
  );
}

export default ContentLayout;
